import { getEmailBatches, resendBatch } from 'lib/api';
import { EMAIL_BATCHES_ACTIONS, QueryParams } from '.';

const {
  GET_EMAIL_BATCHES_START,
  GET_EMAIL_BATCHES_ERROR,
  GET_EMAIL_BATCHES_SUCCESS,
  RESEND_EMAIL_BATCHES_START,
  RESEND_EMAIL_BATCHES_SUCCESS,
  RESEND_EMAIL_BATCHES_ERROR,
} = EMAIL_BATCHES_ACTIONS;

export const loadEmailBatches = async ({
  page,
  size,
  search,
  sort,
  startDate,
  endDate,
  dispatch,
}: QueryParams): Promise<void> => {
  dispatch({ type: GET_EMAIL_BATCHES_START });

  const response = await getEmailBatches({
    page,
    size,
    search,
    sort,
    startDate,
    endDate,
  }).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_EMAIL_BATCHES_ERROR,
      error: response.message,
    });
    return;
  }
  const { emailBatches, count } = response;

  const payload = {
    count,
    emailBatches,
    page,
    size,
    sort,
  };

  dispatch({ type: GET_EMAIL_BATCHES_SUCCESS, payload });
};

export const resendEmailBatch = async ({
  batchId,
  subject,
  dispatch,
}: any): Promise<void> => {
  dispatch({ type: RESEND_EMAIL_BATCHES_START });
  const response = await resendBatch({ batchId, subject }).catch(err => err);

  if (response instanceof Error) {
    dispatch({
      type: RESEND_EMAIL_BATCHES_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = response;

  dispatch({ type: RESEND_EMAIL_BATCHES_SUCCESS, payload });
};
